import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=f29bb7e4&scoped=true&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29bb7e4",
  null
  
)

export default component.exports